"use client"

import { msg } from "@lingui/macro"
import { useLingui } from "@lingui/react"
import { cn } from "@rarible_int/anaconda_ui_components"

export interface ISVGProps extends React.SVGProps<SVGSVGElement> {
  size?: number
  className?: string
}

export function LoadingSpinner({ size = 24, className, ...props }: ISVGProps) {
  const { _ } = useLingui()

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={cn("animate-spin", className)}
    >
      <title>{_(msg`Spinner Icon`)}</title>
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
  )
}
